// Stand-in records until the translation APIs are connected.

export const PAPERS = {
  p3: {
    cover:
      "Read all questions before you begin. Time allowed: 90 minutes. Calculators are not allowed.",
    sections: [
      {
        id: "a",
        name: "Section A",
        english: "Questions 1 to 2. Each question is worth 2 marks.",
        tasks: [
          {
            id: "t1",
            label: "Question 1",
            kind: "mcq",
            englishLabel: "Question 1",
            englishContent: "What is 12 × 8?",
            answers: [
              { english: "96", correct: true },
              { english: "86" },
              { english: "108" },
              { english: "84" },
            ],
          },
          {
            id: "t2",
            label: "Question 2",
            kind: "input",
            englishLabel: "Question 2",
            englishContent: "Write the next number: 2, 4, 8, 16, __",
          },
        ],
      },
      {
        id: "b",
        name: "Section B",
        english: "Questions 3 to 4. Show your working.",
        tasks: [
          {
            id: "t3",
            label: "Question 3",
            kind: "open_ended",
            englishLabel: "Question 3",
            englishContent:
              "A rectangle has a perimeter of 24 cm. Give one possible length and width.",
          },
          {
            id: "t4",
            label: "Question 4",
            kind: "mcq",
            englishLabel: "Question 4",
            englishContent: "Which fraction is the largest?",
            answers: [
              { english: "3/4", correct: true },
              { english: "2/3" },
              { english: "5/8" },
              { english: "1/2" },
            ],
          },
        ],
      },
    ],
  },
  p4: {
    cover: "Answer all questions. Time allowed: 90 minutes.",
    sections: [
      {
        id: "a",
        name: "Section A",
        english: "Questions 1 to 2. 3 marks each.",
        tasks: [
          {
            id: "t1",
            label: "Question 1",
            kind: "mcq",
            englishLabel: "Question 1",
            englishContent: "What is 15% of 80?",
            answers: [
              { english: "12", correct: true },
              { english: "10" },
              { english: "15" },
            ],
          },
          {
            id: "t2",
            label: "Question 2",
            kind: "input",
            englishLabel: "Question 2",
            englishContent: "Solve for x: 3x + 6 = 21",
          },
        ],
      },
    ],
  },
  s1: {
    cover: "This paper has two sections. Attempt every question.",
    sections: [
      {
        id: "a",
        name: "Section A",
        english: "Short answers. 4 marks each.",
        tasks: [
          {
            id: "t1",
            label: "Question 1",
            kind: "open_ended",
            englishLabel: "Question 1",
            englishContent: "Explain why the sum of two odd numbers is even.",
          },
          {
            id: "t2",
            label: "Question 2",
            kind: "mcq",
            englishLabel: "Question 2",
            englishContent: "The gradient of y = 2x + 1 is",
            answers: [
              { english: "2", correct: true },
              { english: "1" },
              { english: "0" },
            ],
          },
        ],
      },
    ],
  },
};

export const COMPETITIONS = [
  {
    id: "sasmo",
    name: "SASMO 2026",
    start: "12 Mar 2026",
    end: "14 Mar 2026",
    status: "Active",
    grades: [
      {
        id: "p3",
        grade: "Grade 3 / Primary 3",
        collection: "SASMO Primary 3",
        languages: ["Chinese", "Malay"],
      },
      {
        id: "p4",
        grade: "Grade 4 / Primary 4",
        collection: "SASMO Primary 4",
        languages: ["Chinese"],
      },
    ],
  },
  {
    id: "simoc",
    name: "SIMOC 2026",
    start: "2 Aug 2026",
    end: "2 Aug 2026",
    status: "Draft",
    grades: [
      {
        id: "s1",
        grade: "Grade 7 / Secondary 1",
        collection: "SIMOC Secondary 1",
        languages: ["Tamil"],
      },
    ],
  },
];

const submitted = new Set([
  "p3|Chinese|cover",
  "p3|Chinese|section:a",
  "p3|Chinese|task:t1",
  "p4|Chinese|cover",
  "p4|Chinese|section:a",
  "p4|Chinese|task:t1",
  "p4|Chinese|task:t2",
]);

const skipped = new Set(["p3|Chinese|task:t2"]);

const drafts = {
  "p3|Chinese|cover|body":
    "开始前请阅读全部题目。时间：90分钟。不可使用计算器。",
  "p3|Chinese|section:a|body": "第1题至第2题。每题2分。",
  "p3|Chinese|task:t1|label": "第1题",
  "p3|Chinese|task:t1|content": "12 × 8 等于多少？",
  "p3|Chinese|task:t1|answer:0": "96",
  "p3|Chinese|task:t1|answer:1": "86",
  "p3|Chinese|task:t1|answer:2": "108",
  "p3|Chinese|task:t1|answer:3": "84",
};

export function progressKey(gradeId, language, part) {
  return `${gradeId}|${language}|${part}`;
}

export function draftKey(gradeId, language, part, field) {
  return `${progressKey(gradeId, language, part)}|${field}`;
}

export function isSubmitted(gradeId, language, part) {
  return submitted.has(progressKey(gradeId, language, part));
}

export function isSkipped(gradeId, language, part) {
  return skipped.has(progressKey(gradeId, language, part));
}

export function isPartDone(gradeId, language, part) {
  return isSubmitted(gradeId, language, part) || isSkipped(gradeId, language, part);
}

export function markSubmitted(gradeId, language, part) {
  submitted.add(progressKey(gradeId, language, part));
}

export function setSkipped(gradeId, language, part, checked) {
  const key = progressKey(gradeId, language, part);
  if (checked) skipped.add(key);
  else skipped.delete(key);
}

export function getDraft(gradeId, language, part, field) {
  return drafts[draftKey(gradeId, language, part, field)] || "";
}

export function setDraft(gradeId, language, part, field, value) {
  drafts[draftKey(gradeId, language, part, field)] = value;
}
